import { combineReducers } from "redux";
//Section UI Processor Reducers
import SingleValue from "src/ui_processors/single_value";

export const otpVerificationSectionReducers = combineReducers({
  currentUserEmail: SingleValue.createReducer("currentUserEmail", "")
});
